<template>
    <div>
        <b-row sm="10">
            <b-col sm="4" class="col text-right">
                <label>รหัสวัตถุดิบ</label>
            </b-col>
            <b-col sm="6">
                <multiselect
                    v-model="form.material"
                    :options="optionMaterial"
                    label="code"
                    disabled
                    :show-labels="false"
                    placeholder="เลือกวัตถุดิบ"
                    track-by="code">
                </multiselect>
            </b-col>
        </b-row>
        <br>
        <b-row sm="10">
            <b-col sm="4" class="col text-right">
                <label>จำนวนที่สั่งซื้อ</label>
            </b-col>
            <b-col sm="6">
                <input class="form-control"
                       type="number"
                       v-model="form.quantity"
                />
            </b-col>
            <div class="col">แพ็ค</div>
        </b-row>
        <br>
        <b-row sm="10">
            <b-col sm="4" class="col text-right">
                <label>ผู้จำหน่าย</label>
            </b-col>
            <b-col sm="6">
                <multiselect
                    v-model="form.vendor"
                    :options="optionVendor"
                    :customLabel="LabelVendor"
                    :show-labels="false"
                    placeholder="เลือกผู้จัดจำหน่าย"
                    track-by="name">
                </multiselect>
            </b-col>
        </b-row>
        <br>
        <b-row sm="10">
            <b-col sm="4" class="col text-right">
                <label>วันที่สั่งซื้อ</label>
            </b-col>
            <b-col sm="6">
                <date-picker v-model="form.date"
                             placeholder="วันที่สั่งซื้อ"
                             :format="changeFormat"
                             :lang="lang" confirm>
                </date-picker>
            </b-col>
        </b-row>
        <br>
        <b-row sm="10">
            <b-col sm="4" class="col text-right">
                <label>หมายเหตุ</label>
            </b-col>
            <b-col sm="6">
                <textarea type="text"
                          class="form-control"
                          placeholder="* วันที่ที่วัตถุดิบมาถึง"
                          v-model="form.remark">
                </textarea>
            </b-col>
        </b-row>
        <br><br>
        <b-row>
            <div class="col text-center">
                <button type="button"
                        @click="submitPOData"
                        class="btn btn-success">
                    <icon name="save" style="width: 25px"></icon>
                    บันทึก
                </button>
                &nbsp&nbsp
                <button type="button"
                        @click="submitCancel"
                        class="btn btn-outline-secondary">
                    <icon name="times" style="width: 25px"></icon>
                    ยกเลิก
                </button>
            </div>
        </b-row>
        <br>
        <!--<pre class="alert alert-primary">{{ form }}</pre>-->
    </div>
</template>

<script>
import {mapState} from "vuex";
import Multiselect from "vue-multiselect";
import DatePicker from 'vue2-datepicker'
import moment from 'moment';

export default {
    name: "edit-pre-order-modal",
    components: {Multiselect, DatePicker},
    created() {
        this.$store.dispatch("Material/getAll");
        this.$store.dispatch("Vendor/getVendorAll");
    },
    data() {
        return {
            changeFormat: {
                stringify: (date) => {
                    let date_moment = moment(date).format('YYYY');
                    const year = parseInt(date_moment) + 543;
                    //console.log(moment(date).format('DD/MM/'+year));
                    return date ? moment(date).format('DD/MM/' + year) : null
                },
                parse: (value) => {
                    return value ? moment(value, 'DD/MM/YYYY').subtract(543, 'y').toDate() : null
                }
            },
            lang: {
                days: ['อา', 'จ', 'อ', 'พ', 'พฤ', 'ศ', 'ส'],
                months: ['มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน', 'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม'],
                pickers: ['ถัดไป 7 วัน', 'ถัดไป 30 วัน', 'ก่อนหน้า 7 วัน', 'ก่อนหน้า 30 วัน'],
                placeholder: {
                    date: 'วว/ดด/ปปปป',
                }
            },
        }
    },
    computed: {
        ...mapState({
            optionMaterial: state => {
                return state.Material.material_all;
            },
            optionVendor: state => {
                return state.Vendor.vendorAll;
            },
            user: state => {
                return state.Auth.user;
            },
            form: state => {
                return state.PreOrder.data;
            }
        })
    },
    methods: {
        LabelVendor(option) {
            return `${option.vendor_id} - ${option.name}`
        },
        submitPOData() {
            if (!this.form.vendor) {
                alert("กรุณาเลือกผู้จำหน่าย")
            } else {
                let data = {
                    id: this.form.id,
                    material_id: this.form.material.id,
                    quantity: this.form.quantity,
                    price: this.form.price,
                    vendor_id: this.form.vendor.id,
                    date: this.form.date,
                    status: this.form.status,
                    user_update_id: this.user.id,
                    remark: this.form.remark
                };
                this.$emit("submit", data);
            }
        },
        submitCancel() {
            this.$emit("submit", 'cancel');
        }
    }
}
</script>

<style scoped>

</style>
